import { GoogleMap, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import emailjs from "emailjs-com";
import React, { useState } from "react";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import HeaderToggle from "../../components/headerToggle/HeaderToggle";
import useWindowSize from "../../hooks/useWindowSize";
import "./ContactScreen.css";

const ContactScreen = () => {
  const { width: screenWidth } = useWindowSize();
  
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyDD_iu8Caz1gB9VuziJmeIzy12i383FCuc",
  });
  
  const center = {
    lat: 40.992583,
    lng: 29.0259958,
  };

  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    phone: "",
    email: "",
    message: "",
  });
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // Telefon için sadece rakam kabul et
    if (name === "phone") {
      if (/^\d{0,11}$/.test(value)) {
        setFormData(prev => ({ ...prev, [name]: value }));
      }
      return;
    }
    
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      await emailjs.send(
        "service_m4f433r",
        "template_ndptx1a",
        formData,
        "dJZ-MViJKu4MPRfu1"
      );
      
      setShowSuccessMessage(true);
      setFormData({ name: "", surname: "", phone: "", email: "", message: "" });
      
      setTimeout(() => {
        setShowSuccessMessage(false);
      }, 5000);
    } catch (error) {
      console.error("E-posta gönderimi başarısız:", error);
      alert("Mesaj gönderilemedi. Lütfen daha sonra tekrar deneyin.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const validateInput = (e) => {
    if (e.target.validity.valueMissing) {
      e.target.setCustomValidity("Bu alan zorunludur.");
    } else if (e.target.name === "email" && !e.target.validity.valid) {
      e.target.setCustomValidity("Geçerli bir e-posta adresi giriniz.");
    } else if (e.target.name === "phone" && !e.target.validity.valid) {
      e.target.setCustomValidity("Lütfen 11 haneli bir telefon numarası giriniz.");
    } else {
      e.target.setCustomValidity("");
    }
  };

  const handleMarkerClick = () => {
    window.open(
      "https://www.google.com/maps/place/Timya+Hotel/@40.992583,29.0259538,21z",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <div className="contact-page">
      {/* Success Message */}
      {showSuccessMessage && (
        <div className="success-message" role="alert">
          <p>Mesajınız başarıyla gönderildi!</p>
          <p>En kısa sürede dönüş yapılacak.</p>
        </div>
      )}

      {/* Header */}
      {screenWidth < 910 ? (
        <HeaderToggle />
      ) : (
        <Header />
      )}

      {/* Header Spacer */}
      <div className="header-spacer" />

      {/* Map Section */}
      {isLoaded && (
        <section className="map-section">
          <GoogleMap
            mapContainerStyle={{
              height: "500px",
              width: "100%",
            }}
            center={center}
            zoom={15}
          >
            <MarkerF
              position={center}
              onClick={handleMarkerClick}
              animation={2}
            />
          </GoogleMap>
        </section>
      )}

      {/* Contact Form Section */}
      <section className="contact-section">
        <div className="contact-explanation-row">
          <h2 className="contact-title">Görüş ve Önerilerinizi Önemsiyoruz</h2>
        </div>

        <form onSubmit={sendEmail} className="contact-form-container">
          <div className="contact-form-row">
            <div className="contact-form">
              <label htmlFor="name">Adınız:</label>
              <input
                id="name"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
                className="contact-input"
                onInvalid={validateInput}
                onInput={(e) => e.target.setCustomValidity("")}
              />
            </div>
            <div className="contact-size-box" />
            <div className="contact-form">
              <label htmlFor="surname">Soyadınız:</label>
              <input
                id="surname"
                type="text"
                name="surname"
                value={formData.surname}
                onChange={handleInputChange}
                required
                className="contact-input"
                onInvalid={validateInput}
                onInput={(e) => e.target.setCustomValidity("")}
              />
            </div>
          </div>

          <div className="contact-form-row">
            <div className="contact-form">
              <label htmlFor="email">E-posta adresiniz:</label>
              <input
                id="email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                className="contact-input"
                onInvalid={validateInput}
                onInput={(e) => e.target.setCustomValidity("")}
              />
            </div>
            <div className="contact-size-box" />
            <div className="contact-form">
              <label htmlFor="phone">Telefon numaranız:</label>
              <input
                id="phone"
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                required
                className="contact-input"
                maxLength="11"
                pattern="\d{11}"
                onInvalid={validateInput}
                onInput={(e) => e.target.setCustomValidity("")}
              />
            </div>
          </div>

          <div className="contact-form contact-form-full">
            <label htmlFor="message">Mesajınız:</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleInputChange}
              required
              className="contact-massage-input"
              onInvalid={validateInput}
              onInput={(e) => e.target.setCustomValidity("")}
            />
          </div>

          <button 
            type="submit" 
            className="submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Gönderiliyor..." : "Gönder"}
          </button>
        </form>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ContactScreen;
